export enum LocalChannel {
  JuvoPos = "JuvoPos",
  JuvoKiosk = "JuvoKiosk",
  JuvoOlo = "JuvOnline",
}
